import React from 'react';
import AutoSizeTitle from '../../components/autoSizeTitle/AutoSizeTitle';
import IndividualInformHeader from '../../components/individualInformHeader/individualInformHeader';
import { formatVisibleNumber } from '../../components/selfcare360/selfcare360Scales';
import {
    formatCompactPercent,
    getIpraDetailedPlanRows,
    getIpraInterventionSummaryRows,
    getIpraPriorityNarrative,
    IPRA_TIER_META,
} from './selfcare360InterventionPlan';
import './planSelfcare360.css';

const formatGenerationDate = () => new Intl.DateTimeFormat('es-CO', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
}).format(new Date());

const getPlanTableRowStyle = (tierKey) => {
    if (tierKey === 'critical') return { backgroundColor: '#FFF1F2' };
    if (tierKey === 'high') return { backgroundColor: '#FFFBEB' };
    if (tierKey === 'moderate') return { backgroundColor: '#FEFCE8' };
    if (tierKey === 'low') return { backgroundColor: '#F0FDF4' };
    return undefined;
};

const PageInterventionPlanSummarySelfcare360 = ({ selectedEvaluation, individualResult, orgLogo, pageNumber }) => {
    const backgroundStyle = {
        backgroundImage: `url('/informs/pagina.png')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left top',
        backgroundSize: '100% auto',
    };

    const rows = getIpraInterventionSummaryRows(individualResult?.average_by_dimension);
    const detailedRows = getIpraDetailedPlanRows(individualResult?.average_by_dimension);
    const generationDate = formatGenerationDate();

    return (
        <div className="pdf-page internal-page">
            <div className="internal-page-content" style={backgroundStyle}>
                <AutoSizeTitle text={selectedEvaluation?.evl_title} />

                <div className="internal-page-info internal-page-info-individual">
                    <IndividualInformHeader individualResult={individualResult} orgLogo={orgLogo} />

                    <div className="selfcare360-plan-page-title">Plan de Intervención</div>
                    <div className="selfcare360-plan-page-subtitle">
                        {getIpraPriorityNarrative(detailedRows)}
                        {' '}
                        Fecha de generación: {generationDate}.
                    </div>

                    <table className="selfcare360-plan-summary-table">
                        <thead>
                            <tr>
                                <th>Dim</th>
                                <th>Nombre</th>
                                <th>Score</th>
                                <th>Peso</th>
                                <th>Aporte</th>
                                <th>Semáforo</th>
                                <th>Prioridad</th>
                                <th>Plazo acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((row) => (
                                <tr key={row.code} style={getPlanTableRowStyle(row.tier.key)}>
                                    <td className="selfcare360-plan-summary-code">{row.code}</td>
                                    <td>{row.summaryTitle}</td>
                                    <td className="selfcare360-plan-summary-score">{formatVisibleNumber(row.score)}</td>
                                    <td className="selfcare360-plan-summary-weight">{formatCompactPercent(row.weightPercent)}</td>
                                    <td className="selfcare360-plan-summary-weight">{formatVisibleNumber(row.weightedContribution)}</td>
                                    <td>
                                        <span
                                            className="selfcare360-plan-badge"
                                            style={{
                                                backgroundColor: row.tierMeta.bgColor,
                                                color: row.tierMeta.textColor,
                                                borderColor: row.tierMeta.borderColor,
                                            }}
                                        >
                                            {row.tierMeta.badgeLabel}
                                        </span>
                                    </td>
                                    <td>{row.priorityLabel}</td>
                                    <td>{row.actionWindow}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div className="selfcare360-plan-legend-row">
                        {Object.entries(IPRA_TIER_META).map(([key, meta]) => (
                            <span
                                key={key}
                                className="selfcare360-plan-badge"
                                style={{
                                    backgroundColor: meta.bgColor,
                                    color: meta.textColor,
                                    borderColor: meta.borderColor,
                                }}
                            >
                                {meta.badgeLabel}
                            </span>
                        ))}
                    </div>

                    <div className="selfcare360-plan-summary-footer">
                        Este plan es generado automáticamente a partir de los resultados del IPRA V3.3. Las acciones descritas están ordenadas por aporte, score y peso dimensional.
                    </div>
                </div>

                <div className="internal-page-number">{pageNumber}</div>
            </div>
        </div>
    );
};

export default PageInterventionPlanSummarySelfcare360;